import { createElementVNode as _$ce, className as _$cn } from 'intact-vue-next';
export default function ($props, $blocks, $__proto__) {
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var k = this.config.k;
  return _$ce(2, 'div', this.get('children'), 0, _$cn(k + "-colorpicker-drag " + k + "-colorpicker-text"), {
    'ev-mousedown': this.drag.start
  });
}
;